<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-xs-12">
                <div class="pb-0 col-sm-12 d-flex mainDiv">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="col-sm-12 col-xs-12 titleDiv CertListTitle  justify-content-between title-area"
                        >
                            <div>
                                <h3>배치 모니터링</h3>
                                <!-- <h5>인증서를 발행할 배치 모니터링을 관리할 수 있습니다.</h5> -->
                            </div>
                        </div>
                        
                        <div class="container-wrapper">
                            <div class="search-filter-container table-info-filter">
                                <div class="search-filter-row">
                                    <div class="search-filter-title">
                                    검색어
                                    </div>
                                    <div class="search-filter-content">
                                    <select class="search-select" v-model="searchFilter.filter">
                                        <option value="batchName">배치 이름</option>
                                    </select>
                                    <div class="search-input-container">
                                        <div class="search-icon">
                                        <i
                                            class="fa-regular fa-magnifying-glass"
                                        />
                                        </div>
                                        <input 
                                        type="text"
                                        class="search-input-text"
                                        v-model="searchFilter.companyName"
                                        @keyup.enter="enter"
                                        placeholder="검색어를 입력하세요"
                                        />
                                    </div>
                                    <button
                                        class="search-btn"
                                        @click="enter"
                                    >
                                        검색
                                    </button>
                                    <button
                                        class="init-btn"
                                        @click="initFilter"
                                    >
                                        초기화
                                    </button>
                                    </div>
                                </div>
                                <div class="search-filter-row">
                                    <div class="search-filter-title">
                                    조회 기간
                                    </div>
                                    <div class="search-filter-content">
                                        <div class="date-filter-container">
                                            <div
                                            class="date-filter-item"
                                            :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                                            @click="handleDateFilter('all')"
                                            >
                                            전체
                                            </div>
                                            <div 
                                            v-for="item in searchFilter.dateFilters" 
                                            class="date-filter-item"
                                            :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                            @click="handleDateFilter(item)"
                                            >
                                            {{ item === 'etc' ? '기간 설정' : `최근 ${convertMonthAndYearText(item)}` }}
                                            </div>
                                        </div>
                                        <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                                            <n-date-picker 
                                            v-model:value="searchFilter.batchStartTime" 
                                            type="date" 
                                            placeholder="시작 날짜를 선택해 주세요."
                                            :on-update:value="handlebatchStartTime"
                                            />
                                            <div>~</div>
                                            <n-date-picker 
                                            v-model:value="searchFilter.batchEndTime" 
                                            type="date" 
                                            placeholder="종료 날짜를 선택해 주세요."
                                            :on-update:value="handlebatchEndTime"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="search-filter-row">
                                    <div class="search-filter-title">
                                    오류 없는 항목만
                                    </div>
                                    <div class="search-filter-content">
                                        <a-checkbox class="filter-checkbox" style="cursor: pointer; " v-model:checked="searchFilter.isNoneError">
                                        </a-checkbox>
                                    </div>
                                </div>
                                <div class="search-filter-row">
                                    <div class="search-filter-title">
                                    배치 시작시간 <br/> 종료 시간 있는 항목 만
                                    </div>
                                    <div class="search-filter-content">
                                        <a-checkbox class="filter-checkbox" style="cursor: pointer; " v-model:checked="searchFilter.isHaveStartTimeAndEndTime">
                                        </a-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container-wrapper">
                            <div class="col-xs-12 table-info-filter">
                                <div class="total-div">
                                    <p>
                                        전체 <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>건
                                    </p>
                                </div>
                                <div class="search-container">
                                    <select 
                                        v-model="rowsPerPage" 
                                        @change="handleRowsPerPage"
                                        style="width: 150px;"
                                    >
                                        <option :value="10">10개씩 보기</option>
                                        <option :value="20">20개씩 보기</option>
                                        <option :value="50">50개씩 보기</option>
                                        <option :value="100">100개씩 보기</option>
                                        <option :value="200">200개씩 보기</option>
                                    </select>
                                    <a-button
                                        @click="deleteMonitoring"
                                        type="primary"
                                        v-if="visibleDeleteMonitoringBtn"
                                    >
                                        <i class="fa-solid fa-trash"/>
                                        삭제완료
                                    </a-button>
                                    <a-button
                                        @click="toggleCheckboxColumn"
                                        type="primary"
                                    >
                                        <i class="fa-solid fa-trash" />
                                        {{ deleteContractTxt }}
                                    </a-button>
                                </div>
                            </div>
                            <a-table 
                                class="ant-table-striped"
                                size="small"
                                :columns="columns"
                                :data-source="responseData"
                                :pagination="false"
                                
                            >
                                    <template #emptyText>
                                        <div class="noData">
                                            <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
                                            <span>{{computedNoResultMessage}}</span>
                                        </div>
                                    </template>
                                    <template #bodyCell="{ column, record }">
                                    </template>
                            </a-table>
                        </div>
                        <pagination 
                        v-if="!$store.state.isLoading && responseData.length > 0"
                        :page-info="paginationData"
                        page-name="ItemList"
                        @change-page="paginationHandler"
                        />
                    </div>
                </div>
            </div>
        </div>
  </div>
  <!-- 에러 메세지 상세보기 모달 -->
  <div
    class="modal fade"
    id="errorMessageModal"
    tabindex="-1"
    aria-labelledby="errorMessageModal"
    aria-hidden="true"
    >
    <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important; max-width: 1000px;"
    >
        <div
        class="modal-content"
        style="width: 100% !important; padding-top: 0.5vw"
        >
            <div class="modal-body" style="display: flex; flex-direction: column">
                <div style="text-align: center; padding-top: 1rem; word-break: break-word;">
                {{ selectErrorMessageRecord?selectErrorMessageRecord.errorDetails : " - "}}
            </div>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import { 
    convertDate, 
    oneBtnDialog, 
    twoBtnDialog,
    confirmDialog, 
    jwtDecoder,
    formatCommaNumber,
    convertMonthAndYearText
} from '@/utils/utils';
import {
    enums,
} from '@/utils/enums'
import NoResult from '@/views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

export default {
    name: 'ItemList',
    components: {
        NoResult,
        Pagination,
    },
    computed: {
        computedNoResultMessage() {
            if(this.calledApiTimes <= 1) {
                return '아직 등록된 배치 모니터링이 없습니다';
            } else {
                return '검색 결과가 없습니다.';
            }
        },
        deleteContractTxt() {
            return this.isCheckboxVisible ? '돌아가기' : '모니터링 삭제'
        },
        visibleDeleteMonitoringBtn() {
            return this.isCheckboxVisible
        },
    },
    data() {
        return {
            convertMonthAndYearText,
            formatCommaNumber,
            addItemPath: '/item/add',
            modalData: '',
            isInputFocused: false,

            // 목록 받아오는 변수
            responseData: [],

            // 페이지네이션 관련 변수
            searchFilter: {
                filter: 'batchName',
                companyName: '',
                batchStartTime: null,
                batchEndTime: null,
                selectedDateFilter: 'all',
                dateFilters: [3, 12, 36, 'etc'],
                isNoneError:false,
                isHaveStartTimeAndEndTime:false,
            },
            previousCondition: '',
            condition: '',
            calledApiTimes: 0,

            selectedItem: '',
            itemDetailData: {},
            deptList: [],
            isZeiss: false,
            columns:[
                    {
                        key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: "4%",
                    },
                    {
                        key: 'companyName', title: '제조사명', dataIndex: 'companyName', align: 'start',
                        customRender: ({text, record}) => {
                            return record.companyName || '-';
                        },
                    },
                    {
                        key: 'batchName', title: '배치 이름', dataIndex: 'batchName', align: 'start',
                        customRender: ({text, record}) => {
                            return record.batchName || '-';
                        },
                    },
                    {
                        key: 'batchStartTime', title: '배치 시작 시간', dataIndex: 'batchStartTime', align: 'start',
                        customRender: ({text, record}) => {
                            return record.batchStartTime || '-';
                        },
                    },
                    {
                        key: 'batchEndTime', title: '배치 종료 시간', dataIndex: 'batchEndTime', align: 'center',
                        customRender: ({text, record}) => {
                            return record.batchEndTime || '-';
                        },
                    },
                    {
                        key: 'batchRunTime', title: '배치 실행시간', dataIndex: 'batchRunTime', align: 'center',
                        customRender: ({text, record}) => {
                            return this.convertRunTime(record.runTime) || '-';
                        },
                    },
                    {
                        key: 'taskCount', title: '수행 건수', dataIndex: 'taskCount', align: 'center',
                        customRender: ({text, record}) => {
                            return record.taskCount || '-';
                        },
                    },
                    {
                        key: 'allTaskCount', title: '전체 수행해야할 건수' ,dataIndex : 'allTaskCount', align: 'center',
                        customRender: ({text, record}) => {
                            return record.allTaskCount || '-';
                        },
                    },
                    {
                        key: 'errorDetails', title: '오류 내용' ,dataIndex : 'errorDetails', align: 'center',
                        customRender: ({text, record}) => {
                            return record.errorDetails ? record.errorDetails.split('\n')[0].slice(0,20)+"..." :'-';
                        },
                    },
                    {
                        key: 'errorDetailsModal', title: '오류 자세히 보기' ,dataIndex : 'errorDetailsModal', align: 'center',
                        customRender: ({text, record}) => (
                            <div
                            style="display: flex; justify-content: center;"
                            >
                                <div
                                    data-bs-toggle="modal"
                                    data-bs-target="#errorMessageModal"
                                    class="certi-custom-btn"
                                    onClick={() => this.selectRecord(record)}
                                >
                                    상세보기
                                </div>
                            </div>
                        ),
                    },
                ],

            listSize: 0,
            rowsPerPage: 10, // Default, can be changed by the user
            paginationData: {
                currentPage: 1, 
                totalPages: 0,
            },
            selectErrorMessageRecord:null,
            isCheckboxVisible: false,
        };
    },
    async mounted() {
        this.checkIsZeiss();

        const obj = {};
        obj.page = this.paginationData.currentPage;
        this.paginationHandler(obj);
    },
    methods: {
        async initFilter() {
            this.searchFilter = {
                filter: 'batchName',
                companyName: '',
                batchStartTime: null,
                batchEndTime: null,
                selectedDateFilter: 'all',
                dateFilters: [3, 12, 36, 'etc'],
                isNoneError:false,
                isHaveStartTimeAndEndTime:false,
            }
            await this.getBatchList();
        },
        async callDeleteApiMonitoring(batchIds, success, fail){
            return await this.$openApiInstance.delete('/batch', {data: {batchIds}})
                .then((response) => {
                    success(response); // 성공 콜백 함수 호출
                })
                .catch((error) => {
                    fail(error); // 실패 콜백 함수 호출
                })
        },
        async deleteMonitoring(){
          const params = this.responseData.filter(d => d.isChecked).map(d => d._id);
          console.log(params)
          if (params.length < 1) {
            await oneBtnDialog('알림', `삭제할 배치 모니터링을 선택해주세요.`)
            return
          }

          const isConfirmed = await twoBtnDialog(`배치 모니터링 삭제`, `선택한 배치 모니터링를 삭제하시겠습니까? 삭제한 배치 모니터링는 복구할 수 없습니다.`, '삭제');
          if (!isConfirmed) return;
          await this.callDeleteApiMonitoring(params, async () => {
            await oneBtnDialog('알림', `${params.length}건의 배치 모니터링이 삭제되었습니다.`).then(async () => {
              this.isCheckboxVisible = false;
              this.columns = this.columns.filter(column => column.key !== 'selection');
              const obj = {};
              obj.page = this.paginationData.currentPage;
              this.paginationHandler(obj);
            })
          }, () => {
            oneBtnDialog('알림', `${params.length}건의 배치 모니터링 삭제에 실패하였습니다.`)
          })
        },
        toggleCheckboxColumn (){
          this.isCheckboxVisible = !this.isCheckboxVisible;

          if (this.isCheckboxVisible) {
            // 선택 컬럼 추가
            const selectionColumn = {
              title: () => {
                const deleteCount = this.responseData.filter(item => item.isChecked).length
                return (
                    <div>
                      <span>{deleteCount}개 선택됨</span><br/>
                      <a-checkbox style={{cursor: "pointer", marginLeft: '8px'}}
                                  onChange={(e) => {
                                    const checkValue = e.target.checked;
                                    this.responseData.forEach(item => {
                                      item.isChecked = checkValue;
                                    });
                                  }
                                  }></a-checkbox>
                    </div>
                );
              },
              key: 'selection',
              width: 60,
              customRender: ({record}) => (<a-checkbox checked={record.isChecked} onChange={(e) => record.isChecked = e.target.checked}></a-checkbox>),
              align: 'center'
            };
            this.columns = [selectionColumn, ...this.columns]; // 선택 컬럼을 목록의 맨 앞에 추가
          } else {
            // 선택 컬럼 제거
            this.columns = this.columns.filter(column => column.key !== 'selection');
          }

          this.enter()
        },
        selectRecord(record){
            this.selectErrorMessageRecord = record;
        },
        // 검색 및관련
        handlebatchStartTime(value) {
            this.searchFilter.batchStartTime = value;
            this.enter();
        },
        handlebatchEndTime(value) {
            this.searchFilter.batchEndTime = value;
            this.enter();
        },
        handleDateFilter(value) {
            if (!value) return;
            if (value === this.searchFilter.selectedDateFilter) return;
            
            this.searchFilter.selectedDateFilter = value;
            if (value === 'all') {
                this.searchFilter.batchStartTime = null;
                this.searchFilter.batchEndTime = null;
            } else {
                this.searchFilter.batchStartTime = this.getPastDatesInUnixTime(value);
                this.searchFilter.batchEndTime = this.getCurrentUnixTime();
            }
            this.enter();
        },

        getPastDatesInUnixTime(value) {
            const now = new Date();
            const threeMonthsAgo = new Date(now.setMonth(now.getMonth() - 3));
            const twelveMonthsAgo = new Date(now.setMonth(now.getMonth() - 9)); 
            const thirtySixMonthsAgo = new Date(now.setMonth(now.getMonth() - 24)); 

            now.setMonth(now.getMonth() + 36);

            const nowUnix = Math.floor(now.getTime());
            const threeMonthsAgoUnix = Math.floor(threeMonthsAgo.getTime());
            const twelveMonthsAgoUnix = Math.floor(twelveMonthsAgo.getTime());
            const thirtySixMonthsAgoUnix = Math.floor(thirtySixMonthsAgo.getTime());

            switch(value) {
                case 3:
                return threeMonthsAgoUnix;
                case 12: 
                return twelveMonthsAgoUnix;
                case 36: 
                return thirtySixMonthsAgoUnix;
                default: 
                return nowUnix;
            }
        },
        
        getCurrentUnixTime() {
            const now = new Date();
            return Math.floor(now.getTime());
        },
        
        convertRunTime(runTime){
            let returnText = '';

            const durationObj = dayjs.duration(runTime, 'seconds');

            const hours = durationObj.hours();
            const minutes = durationObj.minutes();
            const seconds = durationObj.seconds();
            returnText = `${hours}시간 ${minutes}분 ${seconds}초`;
            
            return returnText;
        },
        convertBatchName(batchName){
            let returnValue = batchName;

            switch (batchName) {
                case 'patchDentiumCust':
                    returnValue = '덴티움 거래처(병원)';
                    break;
                case 'patchDentiumInterior':
                    returnValue = '덴티움 거래처(인테리어 업체)';
                    break;
                case 'patchDentiumDept':
                    returnValue = '덴티움 직원';
                    break;
                case 'patchSalesRecord':
                    returnValue = '덴티움 매출';
                    break;
            
                default:
                    break;
            }

            return returnValue;
        },
        convertDate,
        checkIsZeiss() {
            const companyId = jwtDecoder(localStorage.getItem('accessTokenManu'));
            if(companyId && companyId === process.env.VUE_APP_ZEISS_ID) {
                this.isZeiss = true;
            }
        },
        // 주요 API
        async paginationHandler(childPassParam) {
            this.paginationData.currentPage = childPassParam.page;
            await this.getBatchList();
        },
        async enter() {
            this.paginationData.currentPage = 1;
            await this.getBatchList();
        },
        // 배치 모니터링 리스트 가져오기
        async getBatchList() {
            const params = {};
            params.page = this.paginationData.currentPage;
            params.limit = this.rowsPerPage;
            params.search = this.searchFilter.filter;
            params.isNoneError = this.searchFilter.isNoneError;
            params.isHaveStartTimeAndEndTime = this.searchFilter.isHaveStartTimeAndEndTime;

            if(this.searchFilter.companyName) params.condition = this.searchFilter.companyName;
            if(this.searchFilter.batchStartTime && this.searchFilter.batchStartTime) {
                params.batchStartTime = this.unixTimeToYYYYMMDD(this.searchFilter.batchStartTime);
                params.batchEndTime = this.unixTimeToYYYYMMDD(this.searchFilter.batchEndTime);
            }
            try {
                const response = await this.$openApiInstance.get(`/batch`, { params });
                if (response.status === 200 || response.status === 201) {
                this.calledApiTimes ++;

                if(this.previousCondition !== this.condition) {
                    this.paginationData.currentPage = 1;
                } 
                this.previousCondition = this.condition;
                if(response.data.docs) {
                    this.responseData = response.data.docs;
                } else {
                    this.responseData = [];
                }
                this.listSize = response.data.totalDocs;
                for (let i = 0; i < this.responseData.length; i++) {
                    this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
                }
                this.paginationData.totalPages = response.data.totalPages;
            }
        } catch (error) {
            console.log(error);
            await oneBtnDialog('배치 모니터링 목록 로드 실패', '배치 모니터링 목록 로드에 실패하였습니다.', false);
        }
        },
        unixTimeToYYYYMMDD(unixTime) {
            // Create a new Date object from the Unix timestamp
            // Remember to multiply by 1000 because JavaScript expects milliseconds
            const date = new Date(unixTime);

            // Extract the year, month, and day as individual components
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // +1 because getMonth() returns 0-11
            const day = date.getDate().toString().padStart(2, '0');
            // Combine components into YYYYMMDD format
            return `${year}${month}${day}`;
        },
        async handleRowsPerPage() {
            this.paginationData.currentPage = 1;
            await this.getBatchList();
        },
        // 인증서 상태 코드 텍스트로 변환
        // 과명 변환
        convertDeptToText(code) {
            const department = this.deptList.find((item) => item.code === code);
            return department ? department.name : '-';
        },
    },
};
</script>
<style>
.filter-checkbox{
    width: 30px;
    height: 30px;
    .ant-checkbox {
        transform: scale(1.5);
    }

    .ant-checkbox-checked .ant-checkbox-inner,
    .ant-checkbox-inner {
        width: 30px;
        height: 30px;
    }

    .ant-checkbox-inner::after {
        width: 16px;
        height: 16px;
    }

    .ant-checkbox-wrapper {
        font-size: 18px;    
    }
}
</style>
<style lang="scss" scoped>
@import '../assets/scss/common-css.scss';
@import '@/assets/scss/certificates.scss';

.ant-btn {
    border-radius: 6px;
}
.ant-switch{
    border-radius: 100px;
}
.row {
    padding: 28px 28px 72px 28px !important;
}
.ant-table-wrapper {
    overflow-x: auto;
    background-color: white;
}
.ant-btn-primary {
    background-color: #ffe414;
}
.ant-btn {
    color: #17191C;
    height: 40px;
    box-shadow: none !important;
    transition: ease-in-out 0.3s;
    padding: 13px 18px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    transition: ease-in-out 0.3s;
}
</style>
